'use client'

import type { InjectionWidgetComponentProps } from '@open-mercato/shared/modules/widgets/injection'

export default function CimWaybillsTab({ context }: InjectionWidgetComponentProps) {
  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">
        CIM waybills associated with this cargo unit.
      </p>
    </div>
  )
}
